import qs from 'qs'
import { post } from './common/axiosClient'
import { setAuthObj, removeAuthObj, getAccessTokenObject } from './common/storage'
import { AUTH_URL, AUTH_SCOPE } from './common/constants'
import { gqlQuery } from './common/apolloClient'
import { gqlContas, transformConta, gqlInfoExtra, transformInfosAdicionais } from './queries/plans'
import { gqlPedidosEntregasRecargas, transformRastreio } from './queries/tracking'
import { transformOrders } from './queries/orders'

import { gqlTermo } from './queries/term'

import { gqlParametrizacao, gqlEmailsUsuarios } from './queries/parameterization'

export * from '../services-middleware/accountService'

export async function authenticate(login, password, responseCaptcha) {
  return authenticateGQL(login, password)
}

export async function logout() {
  removeAuthObj()
}

export async function authenticateGQL(login, password, responseCaptcha) {
  try {
    let scope
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
    if (login.indexOf('@c6bank.com') !== -1) {
      headers['x-auth-domain'] = 'PORTAL_PJ'
      localStorage.setItem('OauthDomain', 'c6')
    } else {
      localStorage.setItem('OauthDomain', '')
    }

    removeAuthObj()
    const cred = await post(
      AUTH_URL,
      qs.stringify({
        grant_type: 'password',
        scope: scope || AUTH_SCOPE,
        username: login,
        password
      }),
      {
        headers: headers
      }
    )
    setAuthObj(cred)
    const accessToken = getAccessTokenObject()
    // TODO Trata erros
    if (!accessToken || !accessToken.title) {
      throw new Error('accessToken Object is invalid:' + JSON.stringify({ accessToken, cred }))
    }
    return { accountType: accessToken.title.toLowerCase(), success: true, active: true }
  } catch (e) {
    console.error('authenticate failed:', e)
    throw e
  }
}

// FIXME accountId não é passado para a função
export async function getAccountPlans(accountId) {
  // recuperar conta
  let contas = transformConta(await gqlQuery(gqlContas))
  const infoAdicionaisPromises = contas.map(c => gqlQuery(gqlInfoExtra, { idConta: c.id }))
  const infosAdicionais = await Promise.all(infoAdicionaisPromises)
  return contas.map((conta, ind) => ({
    ...conta,
    ...transformInfosAdicionais(infosAdicionais[ind])
  }))
}

export async function getAccountPlansActivation(accountId) {
  // recuperar conta
  let contas = transformConta(await gqlQuery(gqlContas))
  return contas.map((conta, ind) => {
    return {
      ...conta,
      identifiersOrders: [],
      identifiers: []
    }
  })
}

export async function getTermsAndConditions() {
  const {
    data: { buscarTermo = [], buscarTermoPrivacidade = [], buscarManualDoUsuario = [] } = {}
  } = await gqlQuery(gqlTermo)
  const [termo = {}] = buscarTermo
  const termoPrivacidade = buscarTermoPrivacidade
  const manualUsuario = buscarManualDoUsuario
  return { termo, termoPrivacidade, manualUsuario }
}

export const getTrackIdentifiersDetails = async (accountNumber, orderNumber) => {
  const queryresult = await gqlQuery(gqlPedidosEntregasRecargas, { conta: accountNumber })
  return transformRastreio(queryresult, orderNumber)
}

export async function getOrders(conta, type) {
  const result = await gqlQuery(gqlPedidosEntregasRecargas, { conta })
  return transformOrders(result, type)
}

export async function getProfileActivation(parametro) {
  const { data: { parametrizacao } } = await gqlQuery(gqlParametrizacao, { parametro })
  const profileActivationValeu = window.atob(parametrizacao[0].valor)
  return profileActivationValeu
}

export async function getProfilesPartners(param, email) {
  const profilePartners = param.map(item =>
    gqlQuery(gqlEmailsUsuarios, { parametro: item, email: email })
  )
  const profiles = await Promise.all(profilePartners)

  console.log(profiles)
  return profiles.map(profile => {
    const { data: { emailsUsuarios } } = profile
    return emailsUsuarios
  })
}



// WEBPACK FOOTER //
// ./src/alelo-logic/services/accountService.js